<template>
  <div class="row d-flex justify-content-center">
    <div class="col-6">
      <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
        <b-form-group id="input-group-1" label="Usuario:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Ingresa tu usuario"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Contraseña:" label-for="input-2">
          <b-form-input
            id="input-2"
            type="password"
            v-model="form.password"
            required
            placeholder="Ingresa tu password"
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">Ingresar</b-button>
        <b-button type="reset" class="mx-2" variant="danger">Limpiar campos</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
// import bus from '../main'
import EventBus from '../components/EventBus'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      show: true,
      isLogin: false
    }
  },

  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$router.replace('editar')
      } else {
        return
      }
    })

    // console.log('Current-user, Login: ' + firebase.auth().onAuthStateChanged)
    // if (firebase.auth().onAuthStateChanged) {
    //   this.$router.replace('editar')
    // } else {
    //   return
    // }
  },

  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      // this.showNav = !this.show
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(user => {
          console.log('El usuario : \n')
          console.log(user)
          console.log('\n')

          alert(` Bienvenido: ${user.user.email} `)
          firebase.auth().onAuthStateChanged(user)
          this.isLogin = true
          EventBus.$emit('CHECK_LOGIN', this.isLogin)
        })
        .catch(() => {
          alert('No existe el usuario')
        })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.user = ''
      this.form.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.showNav = false
          alert('sesion cerrada')
        })
        .catch(Error => {
          alert(Error)
        })
    }
  }
}
</script>

<style>
#app {
  background-color: aliceblue;
  height: 100vh;
}

.row {
  margin: 0 !important;
}
</style>
